/* @ngInject */
function CampaignFloatingToolBarChecklistsController ($rootScope, $scope, $timeout) {
  const api = {}

  this.getApi = () => api

  activate()

  function activate () {}

  $scope.attachChecklistActions = (selectedChecklist) => {
    $rootScope.$emit('campaign.change-tab-action', 'tab-7')
    /**
     * Emitido com timeout para dar tempo da tab carregar (caso não tenha sido pré-ativada antes).
     */
    $timeout(() => {
      if ($scope.action) {
        $rootScope.$emit('campaign.attach-checklist-actions', selectedChecklist)
      } else {
        $rootScope.$emit('campaign.attach-checklist-new-action', selectedChecklist)
      }

      $rootScope.$emit('campaign.select-checklist-floating-tool-bar', { checklist: null, action: null })
    }, 100)
  }

  $scope.unselectChecklist = () => {
    $rootScope.$emit('campaign.select-checklist-floating-tool-bar', { checklist: null, action: $scope.action })
  }
}

export { CampaignFloatingToolBarChecklistsController }
